import './input.scss';

import { ReactNode, useId } from 'react';

import { toErrorMessage } from './functions/toErrorMessage';
import { InputProps } from './types/InputProps';

export const Input = ({
  className,
  error = false,
  errorTestId,
  label,
  ...props
}: InputProps): ReactNode => {
  const generatedId = useId();
  const inputId = props.id ?? generatedId;

  const hasError = Boolean(error);
  const errorMessage = toErrorMessage(error);

  const fieldClassNames = ['input-field', hasError && 'input-field-error']
    .filter(Boolean)
    .join(' ');

  const inputClassNames = ['input', className].filter(Boolean).join(' ');

  return (
    <div className={fieldClassNames}>
      <input
        aria-invalid={hasError}
        {...props}
        className={inputClassNames}
        id={inputId}
        placeholder=" "
      />

      {label && (
        <label className="input-label" htmlFor={inputId}>
          {label}
        </label>
      )}

      {errorMessage && (
        <span className="field-error" data-testid={errorTestId}>
          {errorMessage}
        </span>
      )}
    </div>
  );
};
